import { sendVirtualMember } from '../services/backendService';
import { takeEvery, put, call, select, take } from 'redux-saga/effects';
import { namespaceActionObject } from './helpers';
import { Map } from 'immutable';
import { fireSmsCreation, REDUCER_ACTIONS as AUTH_ACTIONS, logginSuccess } from './auth';
import { isVirtualOnboarding, updateOnboardingWizardProgress } from './currentProgressOnboardingWizard';
import { fetchUserDetails, REDUCER_ACTIONS as USER_DETAILS_ACTIONS } from '../reducers/userDetails';

// Types

export const REDUCER_ACTIONS = namespaceActionObject('VIRTUALMEMBER')({
  CREATE_VIRTUAL_MEMBER: 'CREATE_VIRTUAL_MEMBER',
  CREATE_VIRTUAL_MEMBER_PENDING: 'CREATE_VIRTUAL_MEMBER_PENDING',
  CREATE_VIRTUAL_MEMBER_ERROR: 'CREATE_VIRTUAL_MEMBER_ERROR',
  CREATE_VIRTUAL_MEMBER_SUCCESS: 'CREATE_VIRTUAL_MEMBER_SUCCESS',
  SEND_VIRTUAL_MEMBER_DETAILS: 'SEND_VIRTUAL_MEMBER_DETAILS',
  SEND_MEMBER_SHIP_PLAN: 'SEND_MEMBER_SHIP_PLAN',
  SEND_PHONE_NUMBER: 'SEND_PHONE_NUMBER'
});

export const REDUCER_STATUS = {
  VIRTUAL_MEMBER_ASKED: 'VIRTUAL_MEMBER_ASKED',
  VIRTUAL_MEMBER_NOT_ASKED: 'VIRTUAL_MEMBER_NOT_ASKED',
  VIRTUAL_MEMBER_PENDING: 'VIRTUAL_MEMBER_PENDING',
  VIRTUAL_MEMBER_SUCCCESS: 'VIRTUAL_MEMBER_SUCCCESS',
  VIRTUAL_MEMBER_ERROR: 'VIRTUAL_MEMBER_ERROR',
  SENDING_VIRTUAL_MEMBER_DETAILS: 'SENDING_VIRTUAL_MEMBER_DETAILS',
  SENDING_MEMBER_SHIP_PLAN: 'SENDING_MEMBER_SHIP_PLAN',
  SENDING_PHONE_NUMBER: 'SENDING_PHONE_NUMBER'
};

// Actions

export const createVirtualMember = userData => ({
  type: REDUCER_ACTIONS.CREATE_VIRTUAL_MEMBER,
  payload: userData
});

export const createVirtualMemberPending = () => ({
  type: REDUCER_ACTIONS.CREATE_VIRTUAL_MEMBER_PENDING
});

export const createVirtualMemberSuccess = () => ({
  type: REDUCER_ACTIONS.CREATE_VIRTUAL_MEMBER_SUCCESS
});

export const createVirtualMemberError = error => ({
  type: REDUCER_ACTIONS.CREATE_VIRTUAL_MEMBER_ERROR,
  payload: error
});

export const sendMemberShipPlan = membershipplan => ({
  type: REDUCER_ACTIONS.SEND_MEMBER_SHIP_PLAN,
  payload: membershipplan
});

export const sendVirtualMemberDetails = virtualMemberDetails => ({
  type: REDUCER_ACTIONS.SEND_MEMBER_SHIP_PLAN,
  payload: virtualMemberDetails
});

export const sendPhoneNumber = phone => ({
  type: REDUCER_ACTIONS.SEND_PHONE_NUMBER,
  payload: phone
});

// Sagas

export function* watchCreateVirtualMember() {
  yield takeEvery(REDUCER_ACTIONS.CREATE_VIRTUAL_MEMBER, creatingVirtualMember);
}

export function* watchLoginRequestVirtualFlow() {
  yield takeEvery(AUTH_ACTIONS.LOGIN_REQUEST, handleLoginRequestVirtualFlow);
}

export function* creatingVirtualMember(action) {
  try {
    yield put(createVirtualMemberPending());
    const virtualMemberDetails = yield select(getVirtualMemberDetails);
    const phone = action.payload;
    const plan = virtualMemberDetails.get('membershipPlan');
    const period = virtualMemberDetails.get('planPeriod');
    const completeData = virtualMemberDetails
      .set('phoneNumber', phone)
      .delete('membershipPlan')
      .delete('planPeriod');
    const { data: memberId } = yield call(sendVirtualMember, plan, completeData, period);
    yield put(fireSmsCreation(phone));
    yield put(sendPhoneNumber(phone));
    yield put(sendVirtualMemberDetails({ id: memberId }));
    yield put(createVirtualMemberSuccess());
  } catch (error) {
    yield put(createVirtualMemberError(error));
  }
}

export function* handleLoginRequestVirtualFlow() {
  const isVirtualFlow = yield select(isVirtualOnboarding);
  if (isVirtualFlow) {
    const CREDIT_CARD_STEP_NUMBER = 5;
    yield put(fetchUserDetails());
    yield take(USER_DETAILS_ACTIONS.FETCH_USER_DETAILS_SUCCESS);
    yield put(updateOnboardingWizardProgress(CREDIT_CARD_STEP_NUMBER, new Map()));
    yield put(logginSuccess());
  }
}

// State Mappers

export const getVirtualMemberDetails = state => state.virtualMemberDetails.get('virtualMemberDetails');
export const getVirtualMemberPhone = state => state.virtualMemberDetails.get('phone');
export const didVirtualMemberFail = state => state.virtualMemberDetails.get('status') === REDUCER_STATUS.VIRTUAL_MEMBER_ERROR;
export const isVirtualMemberPending = state => state.virtualMemberDetails.get('status') === REDUCER_STATUS.VIRTUAL_MEMBER_PENDING;
export const isVirtualMemberSuccess = state => state.virtualMemberDetails.get('status') === REDUCER_STATUS.VIRTUAL_MEMBER_SUCCCESS;

const initState = Map({
  status: REDUCER_STATUS.VIRTUAL_MEMBER_NOT_ASKED,
  virtualMemberDetails: Map(),
  phone: ''
});

export default (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case REDUCER_ACTIONS.CREATE_VIRTUAL_MEMBER_SUCCESS:
      return state.set('status', REDUCER_STATUS.VIRTUAL_MEMBER_SUCCCESS);
    case REDUCER_ACTIONS.CREATE_VIRTUAL_MEMBER_PENDING:
      return state.set('status', REDUCER_STATUS.VIRTUAL_MEMBER_PENDING);
    case REDUCER_ACTIONS.CREATE_VIRTUAL_MEMBER_ERROR:
      return state.set('status', REDUCER_STATUS.VIRTUAL_MEMBER_ERROR);
    case REDUCER_ACTIONS.SEND_VIRTUAL_MEMBER_DETAILS:
      return state.merge({
        status: REDUCER_STATUS.SENDING_VIRTUAL_MEMBER_DETAILS,
        virtualMemberDetails: state.get('virtualMemberDetails').merge(payload)
      });
    case REDUCER_ACTIONS.SEND_MEMBER_SHIP_PLAN:
      return state.merge({ status: REDUCER_STATUS.SENDING_MEMBER_SHIP_PLAN, virtualMemberDetails: state.get('virtualMemberDetails').merge(payload) });
    case REDUCER_ACTIONS.SEND_PHONE_NUMBER:
      return state.merge({ status: REDUCER_STATUS.VIRTUAL_MEMBER_PENDING, phone: payload });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/authVirtualMember.js